import log from 'util/logger'
import * as globalCommands from 'init/global-commands'

// An array of commands submitted by the client
let queue
// Help make sure commands are not executed twice
let isProcessingQueue = false

/**
 * Called by the page entry js once the widgets have been initialized, but not necessarily mounted
 */
export function init() {
  // determine the name of the command function the client is using
  const cmdObjName = window.TurnToCmdObjectName || 'TurnToCmd'
  // get the commands that already queued up
  queue = window[cmdObjName] ? (window[cmdObjName].q || []) : []
  // reassign the command object to point to internal function
  window[cmdObjName] = queueAndRunCommands
  // call to run commands in case any are already in the queue
  runCommands()
}

/**
 * Widget loaders assign the function calls that can be made
 */
export const widgetLibraries = {
  chatter: {},
  commentsPinboard: {},
  commentsPinboardTeaser: {},
  feed: {},
  gallery: {},
  global: globalCommands,
  instantAnswers: {},
  qa: {},
  reviewsList: {},
  reviewsSummary: {},
  spectrum: {},
  topComments: {},
  userToolbar: {},
  vcPinboard: {}
}

// Function that the command object is assigned to when initialized
function queueAndRunCommands() {
  queue.push(arguments)
  runCommands()
}

// Run any commands that are in the queue
function runCommands() {
  if (!isProcessingQueue) {
    isProcessingQueue = true
    while (queue.length) {
      // removes the first item from the queue and converts the Arguments object to an array
      const args = Array.prototype.slice.call(queue.shift())
      // called without args
      if (args.length === 0) {
        log.error('TurnToCmd called without any arguments')
        continue
      }

      // If the command contains a dot, then it's a specific widget command.
      // If no dot, it should be a global command.
      const cmd = args[0]
      let libraryName = 'global'
      let fnName = cmd
      if (~cmd.indexOf('.')) {
        const cmdParts = cmd.split('.')
        libraryName = cmdParts[0]
        fnName = cmdParts[1]
      }
      const fn = widgetLibraries[libraryName] ? widgetLibraries[libraryName][fnName] : undefined
      if (!isFunction(fn)) {
        log.error(`"${cmd}" is not a valid command.`)
        continue
      }
      // finally verified, we can call the function.  Doesn't mean it won't fail if the arguments
      // for the function are incorrect
      const functionArgs = args.length > 1 ? args.slice(1) : []
      fn.apply(null, functionArgs)
    }
    isProcessingQueue = false
  }
}

function isFunction(fn) {
  return typeof fn === 'function'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/init/command-queue.ts